import { useState, useEffect, useCallback } from 'react';

export type ExitHandler = () => void;

function useChainedTransition(
  isFirstIn: boolean,
): [boolean, boolean, ExitHandler, ExitHandler] {
  const [firstIn, setFirstIn] = useState(isFirstIn);
  const [secondIn, setSecondIn] = useState(!isFirstIn);

  useEffect(() => {
    if (isFirstIn) {
      secondIn && setSecondIn(false);
    } else {
      firstIn && setFirstIn(false);
    }
  }, [isFirstIn, firstIn, secondIn]);

  const handleFirstExited = useCallback(() => {
    setSecondIn(true);
  }, [setSecondIn]);

  const handleSecondExited = useCallback(() => {
    setFirstIn(true);
  }, [setFirstIn]);

  return [firstIn, secondIn, handleFirstExited, handleSecondExited];
}

export default useChainedTransition;
